/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Modal, ModalBody } from "reactstrap";

import "../layouts/App.scss";
import "./assets/style.scss";

import Site from "./Site";
import SiteCustom from "./SiteCustom";
import SiteDraw from "./SiteDraw";
import Equipment from "./Equipment";

import throttle from "lodash.throttle";

import MenuLeft from "./components/MenuLeft";
import Header from "./components/Header";
import PreLoader from "./components/PreLoader";
import Cart from "./components/Cart";

import { textures } from "./Textures";

import {
  STORAGE_KEY,
  TOP_VIEW_IMAGE_INDEX,
  IZO_TRANSFORM_A,
  IZO_TRANSFORM_B,
  IZO_TRANSFORM_C,
  IZO_TRANSFORM_D,
  squareSize,
  grassMod,
} from "../../utils/Constant";

import * as API from "../../api";
import * as Actions from "../../actions";
import {
  constructSaveAs,
  getItemAttributeInConstructor,
} from "../../api/catalog";
import * as HelperCanvas from "../../utils/HelperCanvas";
import PopupEquipment from "./components/Popup/PopupEquipment";

const fieldDefaultDimension = 7,
  scale = 1,
  scaleMin = 0.3,
  scaleMax = 1,
  canvasOffset = { x: 60, y: 50 };

const drawMode = false;

class Constructor extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getInitState();
    this.playgroundRef = null;
    this.setPlaygroundRef = (element) => {
      this.playgroundRef = element;
    };

    this.turnEquipment = this.turnEquipment.bind(this);
    this.moveEquipmentByDir = this.moveEquipmentByDir.bind(this);

    this.cloneEquipment = this.cloneEquipment.bind(this);
    this.deleteEquipment = this.deleteEquipment.bind(this);

    //this.onHandlerMoveThrottled = throttle(this.handlerMove, 100)

    this.handlerMoveThrottle = throttle(this.handlerMove.bind(this), 40);
  }

  loadingGrounds = async () => {
    //loaded
    await Promise.all(textures.map(this.checkImage));

    const grounds = [
      "squareDefault",
      "squareScreening",
      "squareBgYellowLight",
      "squareYellow",
      "squareOrange",
      "squareOrangeDark",
      "squareRed",
      "squareGreen",
      "squareBlue",
      "squareAzure",
      "squarePurple",
      "squareGray",
      "squareGrayLight",
      "squareBrown",
    ];

    this.setState({
      ready: true,
      preLoader: false,
      grounds: grounds.map((ground) => {
        return { img: this.state[ground], name: ground };
      }),
    });
  };

  loadPlaygroundByHash = () => {
    let params = new URL(document.location).searchParams;
    const hash = params.get("p");

    if (hash) {
      API.catalog.loadPlaygroundFromDb(params.get("p")).then((data) => {
        this.setState({ ...data });

        const dimensions = this.getCanvasSize();
        this.setState({ ...dimensions });

        //window.location
        this.updateCanvasSize();
      });
    }
  };

  componentDidMount = async () => {
    this.props.catalogFindAll(true);
    this.props.loadCartFromLocalStore();

    window.addEventListener("resize", this.updateCanvasSize);
    window.addEventListener("keydown", this.handlerKeyDown);

    await this.loadingGrounds();
    this.updateCanvasSize();
    this.loadPlaygroundByHash();
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateCanvasSize);
    window.removeEventListener("keydown", this.handlerKeyDown);
  };

  componentDidUpdate() {
    this.setToLocalStore();
  }

  getParentCategoryId = () => {
    return this.state.sidebar &&
      this.state.sidebar.currentCategory &&
      this.state.sidebar.currentCategory.pid
      ? this.state.sidebar &&
          this.state.sidebar.currentCategory &&
          this.state.sidebar.currentCategory.pid
      : null;
  };

  checkImage = (data) =>
    new Promise((resolve) => {
      if (data) {
        let img = new Image();
        img.onload = () => resolve({ img, status: "ok" });
        img.onerror = () => resolve({ data, status: "error" });
        img.src = data.path;

        this.setState({
          [data.prop]: img,
        });
      }
    });

  newPlayground = () => {
    localStorage.removeItem("playground");
    window.location.href = window.location.href.split("?").shift();
  };

  toggleSidebarLeft = () => {
    this.setState({
      sidebar: {
        ...this.state.sidebar,
        collapse: !this.state.sidebar.collapse,
        isSearch: false,
      },
    });
  };

  toggleModal = (modalName, fileSrc) => {
    let modal = { ...this.state.modal };
    modal[modalName] = !modal[modalName];

    this.setState({
      modal,
      saveAsFile: fileSrc,
    });
  };

  toggleSaveImageModal = (saveAsFile = null) => {
    this.toggleModal("saveImage", saveAsFile);
  };

  toggleOrderModal = (saveAsFile = null) => {
    this.toggleModal("orderModal", saveAsFile);
    // Обновляем playgroundId только если он пришел с новым значением
    if (
      saveAsFile &&
      saveAsFile.id &&
      saveAsFile.id !== this.state.playgroundId
    ) {
      this.setState(
        {
          playgroundId: saveAsFile.id,
        },
        () => {
          this.setToLocalStore();
        }
      );
    }
  };

  getCanvasSize = () => {
    let playground = this.playgroundRef;
    if (!playground) {
      playground = document.getElementById("Playground");
    }
    const offset = canvasOffset;

    this.setState({ offset });

    if (playground) {
      return {
        width: playground.offsetWidth,
        height: playground.offsetHeight,
      };
    }

    return {
      width: playground.offsetWidth,
      height: playground.offsetHeight,
    };
  };

  updateCanvasSize = () => {
    this.setState({ preLoader: true });
    const dimensions = this.getCanvasSize();

    const center = this.getCenter();
    const { position } = this.state;

    if (isNaN(position.x) || isNaN(position.y)) {
      const position = {
        x: dimensions.width / 2 - center.x,
        y: dimensions.height / 2 - center.y,
      };
      this.setState({ ...dimensions, position });
    } else {
      this.setState({ ...dimensions });
    }

    setTimeout(() => {
      this.setState({ preLoader: false });
    }, 500);
  };

  getInitState = (useCache = true) => {
    const { width, height } = this.getWindowSize();

    let state = {
      sidebar: {
        collapse: false,
        currentCategory: { pid: null, id: null },
        categories: [],
        items: [],
      },
      modal: {
        saveImage: false,
      },
      saveAsFile: "",
      offset: { x: 0, y: 0 },
      ready: false,
      playgroundId: 0,
      preLoader: true,
      width,
      height,
      scale,
      squareSize,
      square: "squareDefault",
      squareDefault: null,
      grassMod,
      field: {
        width: fieldDefaultDimension,
        height: fieldDefaultDimension,
      },
      siteSelected: null,

      site: { items: [] },
      siteCustom: { active: false },
      position: {},
      grounds: [],
    };

    if (localStorage.hasOwnProperty(STORAGE_KEY) && useCache) {
      const playground = JSON.parse(localStorage.getItem(STORAGE_KEY));

      if (!playground.coordinates) {
        playground.coordinates = this.getCoordinates(state.field);
      }
      if (!playground.name) {
        playground.name = 'Новая площадка';
      }

      state = {
        ...state,
        ...playground,
        ready: false,
        preLoader: true,
        oldPosition: {},
      };
    } else {
      const center = this.getCenter(state);

      state.name = 'Новая площадка';
      state.position = {
        x: width / 2 - center.x * scale,
        y: height / 2 - center.y * scale,
      };
      state.coordinates = this.getCoordinates(state.field);
    }

    return state;
  };

  getWindowSize = () => {
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    const height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;

    return {
      width: width - 250,
      height: height - 50,
    };
  };

  getCoordinates = (field = null) => {
    if (field === null) {
      field = this.state.field;
    }

    return [
      { x: 0, y: 0 },
      { x: field.width, y: 0 },
      { x: field.width, y: field.height },
      { x: 0, y: field.height },
    ];
  };

  /**
   *
   * @param a
   * @param b
   * @return {{x: number, y: number}}
   */
  pointCoordinate = (a, b) => {
    const { position, scale } = this.state;

    const x = a * IZO_TRANSFORM_A + b * IZO_TRANSFORM_C + position.x / scale;
    const y =
      a * IZO_TRANSFORM_B - b * (-1 * IZO_TRANSFORM_D) + position.y / scale;

    return { x, y };
  };

  getCells = () => {
    const { field, squareSize: square, grassMod } = this.state;

    const width = field.width * square + square * grassMod;
    const height = field.height * square + square * grassMod;
    const grassSize = square * grassMod;

    let result = [];

    for (let a = grassSize, x = 0; a < width; a += square, x++) {
      for (let b = grassSize, y = 0; b < height; b += square, y++) {
        result.push([
          // 0 0
          this.pointCoordinate(a, b),
          // 0 1
          this.pointCoordinate(a + square, b),
          // 1 1
          this.pointCoordinate(a + square, b + square),
          // 1 0
          this.pointCoordinate(a, b + square),
          //0 0
          this.pointCoordinate(a, b),
        ]);
      }
    }

    return result;
  };

  //FieldCenter
  getCenter = (state = null) => {
    if (state === null) {
      state = this.state;
    }

    const grassWidth = state.squareSize * state.grassMod * 2;
    const w = (state.field.width * state.squareSize + grassWidth) / 2;
    const h = (state.field.height * state.squareSize + grassWidth) / 2;

    return {
      x: IZO_TRANSFORM_A * w + IZO_TRANSFORM_C * h,
      y: IZO_TRANSFORM_B * w + IZO_TRANSFORM_D * h,
    };
  };

  getDimensionsToCenter = (center, scale = this.state.scale) => {
    if (!center) {
      center = this.getCenter();
    }
    const dimensions = this.getDimensions();

    return {
      x: dimensions.width / 2 - center.x * scale - this.state.position.x,
      y: dimensions.height / 2 - center.y * scale - this.state.position.y,
    };
  };

  getDimensions = () => {
    return {
      width: this.state.width | 5,
      height: this.state.height | 5,
    };
  };

  setSiteCtx = (siteCtx) => {
    this.setState({ siteCtx });
  };

  setEquipmentCtx = (index, ctx) => {
    let items = this.state.site.items;
    items[index]["ctx"] = ctx;

    this.setState({
      site: { ...this.state.site, items },
    });
  };

  setToLocalStore = () => {
    let state = { ...this.state };

    delete state.siteCtx;
    delete state.saveAsFile;

    if (!state.name) {
      state.name = 'Новая площадка';
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  };

  setGround = (square) => {
    this.setState({ square });
  };

  setCategory = (currentCategory) => {
    const prevCategory = this.state.sidebar.currentCategory || {};
    if (currentCategory.id === prevCategory.id && currentCategory.id !== null) {
      currentCategory.id = null;
    } else if (
      currentCategory.pid === prevCategory.pid &&
      currentCategory.id === null
    ) {
      currentCategory.pid = null;
      currentCategory.id = null;
    }

    if (currentCategory.pid && currentCategory.pid !== prevCategory.pid) {
      //this.findAllItemByCategoryId(currentCategory.pid);
    }
    this.props.search("");
    this.setState({
      sidebar: { ...this.state.sidebar, currentCategory, isSearch: false },
    });
  };

  findAllItemByCategoryId = (id) => {
    this.props.findAllItemByCategoryId(id);
  };

  updateCoordinates = (coordinates) => {
    this.setState({ coordinates });
  };

  updateBases = (paths) => {
    this.setState({ paths });
  };

  updateScale = (e) => {
    //e.preventDefault();

    let scale = this.state.scale + 0.1 * (e.deltaY > 0 ? -1 : 1);
    const scaleOld = this.state.scale;

    if (scale < scaleMin) {
      scale = scaleMin;
    } else if (scale > scaleMax) {
      scale = scaleMax;
    }

    if (scale !== scaleOld) {
      const center = this.getCenter(),
        dem = this.getDimensionsToCenter(center),
        { width, height } = this.getDimensions();

      const x = width / 2 - center.x * scale - dem.x;
      const y = height / 2 - center.y * scale - dem.y;

      this.setState({ scale });
      this.updatePosition(x, y);

      const dx =
        width / scaleOld / 2 -
        width / scale / 2 -
        (dem.x / scaleOld - dem.x / scale);
      const dy =
        height / scaleOld / 2 -
        height / scale / 2 -
        (dem.y / scaleOld - dem.y / scale);

      this.updateEquipmentPosition(dx, dy);
    }
  };

  updatePosition = (x, y) => {
    if (!isNaN(x) && !isNaN(y)) {
      this.setState({ position: { x, y } });
    }
  };

  removeItem = (index) => {
    let items = this.state.site.items;
    items.splice(index, 1);

    this.setState({
      site: { ...this.state.site, items },
    });
  };

  addEquipment = (item) => {
    getItemAttributeInConstructor(item.id).then((data) => {
      if (isNaN(item.index)) {
        item.index = 0;
      }

      this.setState({
        site: {
          ...this.state.site,
          items: [
            ...this.state.site.items,
            {
              ...item,
              ...data,
              position: { ...this.moveToCenter() },
            },
          ],
        },
      });
    });
  };

  updateEquipmentPosition = (x, y) => {
    let items = this.state.site.items.map((item) => {
      return {
        ...item,
        position: {
          x: item.position.x - x,
          y: item.position.y - y,
        },
      };
    });

    this.setState({
      site: { ...this.state.site, items },
    });
  };

  //похоже нужен фикс
  moveToCenter = () => {
    const { scale, position, field, squareSize, grassMod } = this.state;
    const grassWidth = squareSize * grassMod * 2;

    return {
      x: position.x / scale + (field.width * squareSize + grassWidth) / 2,
      y: position.y / scale + (field.height * squareSize - grassWidth) / 2,
    };
  };

  /**
   * @param selectedEquipment
   * @param x
   * @param y
   * @param isTopView
   * @param baseXY
   */
  moveEquipment = (selectedEquipment, x, y, isTopView, baseXY) => {
    let dx = x,
      dy = y,
      items = this.state.site.items;
    let scale = this.state.scale;
    let index = selectedEquipment.index;

    if (!isNaN(x) && !isNaN(y) && items[index]) {
      if (selectedEquipment.oldPosition) {
        if (isTopView) {
          let dxy = HelperCanvas.calculateTopViewXYMovement(
            x,
            y,
            selectedEquipment,
            baseXY,
            scale,
            IZO_TRANSFORM_A,
            IZO_TRANSFORM_B,
            IZO_TRANSFORM_C,
            IZO_TRANSFORM_D
          );
          dx = dxy.x;
          dy = dxy.y;
        } else {
          dx = x / scale - selectedEquipment.oldPosition.x;
          dy = y / scale - selectedEquipment.oldPosition.y;
        }
      }

      //если не пересекается то обновляем позицию, то подсвечиваем красным

      const nextPosition = { x: dx, y: dy };

      items[[index]] = {
        ...items[index],
        limitColor: "yellow",
        position: nextPosition,
      };

      this.setState({
        site: { ...this.state.site, items },
        equipmentPopUp: {
          ...this.state.equipmentPopUp,
          equipmentNextPosition: nextPosition,
        },
      });
    }
  };

  updateFieldSize = (props, value) => {
    const field = { ...this.state.field, [props]: value };
    this.setState({
      field,
      coordinates: this.getCoordinates(field),
    });
  };

  isHit = (x, y) => {
    let siteCtx = this.state.siteCtx;
    siteCtx.globalCompositeOperation = "source-over";
    const { field, squareSize, grassMod } = this.state;
    siteCtx.rect(
      0,
      0,
      field.width * squareSize + squareSize * grassMod * 2,
      field.height * squareSize + squareSize * grassMod * 2
    );
    return siteCtx.isPointInPath(x, y);
  };

  toggleSiteSelected = (siteSelected, x, y) => {
    if (this.isHit(x, y)) {
      this.setState({ siteSelected });
      return true;
    }

    this.setState({ siteSelected: null });
    return false;
  };

  toggleSiteCustom = () => {
    this.setState({
      siteCustom: {
        ...this.state.siteCustom,
        active: !this.state.siteCustom.active,
      },
    });
  };

  toggleView = () => {
    this.setState({
      siteCustom: {
        ...this.state.siteCustom,
        viewTop: !this.state.siteCustom.viewTop,
      },
      square: this.state.siteCustom.viewTop ? "squareDefault" : "squareBgWhite",
    });
  };

  /**
   * проверяем есть ли оборудование в координатах клика
   * если есть то возвращаем его индекс
   * @param x
   * @param y
   */
  getEquipmentIndexByCoordinate = (x, y) => {
    let equipmentIndex = null;

    this.state.site.items.forEach((equipment, index) => {
      if (
        equipment.ctx instanceof CanvasRenderingContext2D &&
        equipment.ctx.isPointInPath(x, y)
      ) {
        equipmentIndex = index;
        return true;
      }

      return false;
    });

    return equipmentIndex;
  };

  /**
   * попап для оборудования со стрелочками
   * @param index
   * @param equipment
   * @param coordinates
   * @param selectedEquipment
   */
  toggleEquipmentPopUp = (
    index = null,
    equipment = null,
    coordinates = null,
    selectedEquipment = null
  ) => {
    if (index === null && this.state.equipmentPopUp) {
      let items = this.state.site.items,
        item = items[this.state.equipmentPopUp.index];

      if (item) {
        items[this.state.equipmentPopUp.index].limitColor = "transparent";
      }

      this.setState({
        site: { ...this.state.site, items },
        equipmentPopUp: null,
      });
    } else if (index !== null) {
      this.setState({
        equipmentPopUp: { index, coordinates, equipment, selectedEquipment },
      });
    }
  };

  /**
   * @param dir
   */
  turnEquipment = (dir) => {
    if (this.state.equipmentPopUp) {
      let items = this.state.site.items,
        item = items[this.state.equipmentPopUp.index];

      if (item) {
        let activeImgIndex = parseInt(item.activeImgIndex, 10);
        let max = item.images.length - 1;

        if (isNaN(activeImgIndex)) {
          activeImgIndex = 0;
        }

        //(временно таким способом) из-за 9-й картинки с видом сверху уменьшим индекс на 1
        if (max > 7) {
          max--;
        }

        if (max < 0) {
          max = 0;
        }

        if (dir === "right") {
          if (activeImgIndex > 0) {
            activeImgIndex--;
          } else {
            activeImgIndex = max;
          }
        } else if (dir === "left") {
          if (activeImgIndex + 1 > max) {
            activeImgIndex = 0;
          } else {
            activeImgIndex++;
          }
        }

        item.activeImgIndex = activeImgIndex;
      }

      this.setState({
        site: { ...this.state.site, items },
      });
    }
  };

  moveEquipmentByDir = (dir) => {
    if (this.state.equipmentPopUp) {
      let items = this.state.site.items,
        item = items[this.state.equipmentPopUp.index];

      switch (dir) {
        case "up":
          item.position = {
            x: item.position.x - 8.5,
            y: item.position.y - 10,
          };
          break;
        case "down":
          item.position = {
            x: item.position.x + 8.5,
            y: item.position.y + 10,
          };
          break;
        case "right":
          item.position = {
            x: item.position.x + 10,
            y: item.position.y - 3.9,
          };
          break;
        case "left":
          item.position = {
            x: item.position.x - 10,
            y: item.position.y + 3.9,
          };
          break;

        default:
          return false;
      }

      this.updateEquipments(items);
    }
  };

  changeLayer = (dir) => {
    let items = [...this.state.site.items];
    const { equipmentPopUp } = this.state;
    const nextIndex =
      dir === "up" ? equipmentPopUp.index + 1 : equipmentPopUp.index - 1;
    const newState = HelperCanvas.arrayMove(
      items,
      equipmentPopUp.index,
      nextIndex
    );

    this.setState({
      site: {
        ...this.site,
        items: newState,
      },
      equipmentPopUp: {
        ...equipmentPopUp,
        index: nextIndex,
      },
    });
  };

  cloneEquipment = () => {
    if (this.state.equipmentPopUp) {
      let items = this.state.site.items,
        item = { ...items[this.state.equipmentPopUp.index] };

      item.position = {
        x: item.position.x + 100,
        y: item.position.y + 100,
      };
      items.push(item);

      this.updateEquipments(items);
      this.toggleEquipmentPopUp();
    }
  };

  deleteEquipment = () => {
    if (this.state.equipmentPopUp) {
      let items = this.state.site.items;
      items.splice(this.state.equipmentPopUp.index, 1);

      this.setState({
        site: { ...this.state.site, items },
      });
    }
    this.toggleEquipmentPopUp();
  };

  updateEquipments = (items) => {
    this.setState({ site: { ...this.state.site, items } });
  };

  /**
   * выбор оборудования
   * @param index
   * @param coordinates
   */
  selectEquipmentByIndex = (index, coordinates) => {
    let { scale, site } = this.state;
    let items = site.items,
      item = items[index];

    if (item) {
      const { x, y } = item.position;
      item.limitColor = "green";

      const selectedEquipment = {
        index,
        oldPosition: {
          x: coordinates.x / scale - x,
          y: coordinates.y / scale - y,
        },
        clickCoordinates: coordinates,
        oldIzoPosition: item.position,
      };

      this.setState({
        site: { ...site, items },
        selectedEquipment,
      });
      this.toggleEquipmentPopUp(index, item, coordinates, selectedEquipment);
    }
  };

  unSelectEquipmentByIndex = (index) => {
    let items = this.state.site.items;

    items[[index]] = {
      ...this.state.site.items[index],
      limitColor: "transparent",
    };

    this.setState({
      site: {
        ...this.state.site,
        items,
      },
      selectedEquipment: false,
    });
  };

  unSelectEquipmentAll = () => {
    let items = this.state.site.items;
    this.toggleEquipmentPopUp();

    if (items) {
      for (let i = 0; i < items.length; i++) {
        this.unSelectEquipmentByIndex(i);
      }
    }
  };

  handlerKeyDown = (e) => {
    switch (e.keyCode) {
      case 27:
        this.toggleEquipmentPopUp();
        break;
      case 46:
        this.deleteEquipment();
        break;
      default:
        return true;
    }
  };

  onMove = (e) => {
    e.persist();
    this.handlerMoveThrottle(e);
  };

  handlerMove = (e) => {
    const {
      site,
      scale,
      offset,
      siteSelected,
      selectedEquipment,
      position,
      siteCustom,
    } = this.state;
    const x = e.clientX - offset.x,
      y = e.clientY - offset.y;

    if (selectedEquipment) {
      this.moveEquipment(selectedEquipment, x, y, siteCustom.viewTop, position);
    } else if (site.isSelected) {
      //перемещение площадки, поэтому перемещаем все изделия вместе с ней
      const dx = x - siteSelected.x;
      const dy = y - siteSelected.y;

      let items = site.items.map((equipment) => {
        equipment.position = equipment.position
          ? {
              x: equipment.position.x - (position.x - dx) / scale,
              y: equipment.position.y - (position.y - dy) / scale,
            }
          : {
              x: 0,
              y: 0,
            };

        return equipment;
      });

      this.updatePosition(dx, dy);
      this.setState({
        site: { ...site, items },
      });
    }
  };

  handlerOnMouseDown = (e) => {
    const coordinates = {
      x: e.clientX - this.state.offset.x,
      y: e.clientY - this.state.offset.y,
    };

    const equipmentIndex = this.getEquipmentIndexByCoordinate(
      coordinates.x,
      coordinates.y
    );

    this.unSelectEquipmentAll();

    //selected site
    if (equipmentIndex === null && !this.state.siteCustom.active) {
      const oldPosition = {
        x: coordinates.x - this.state.position.x,
        y: coordinates.y - this.state.position.y,
      };

      this.setState({
        site: {
          ...this.state.site,
          isSelected: this.toggleSiteSelected(
            oldPosition,
            coordinates.x,
            coordinates.y
          ),
        },
      });
    } else {
      //клик по оборудованию
      this.selectEquipmentByIndex(equipmentIndex, coordinates);
    }
  };

  handlerOnMouseUp = (e) => {
    if (this.state.selectedEquipment) {
      let items = this.state.site.items;

      items[this.state.selectedEquipment.index] = {
        ...this.state.site.items[this.state.selectedEquipment.index],
        limitColor: "green",
      };

      this.setState({
        site: {
          ...this.state.site,
          items,
          isSelected: false,
        },
        selectedEquipment: false,
      });
    } else {
      this.setState({
        site: {
          ...this.state.site,
          isSelected: false,
        },
      });
    }
  };

  /**
   * Координаты для попап меню
   */
  getEquipmentPopUpCoordinates = () => {
    const { scale, equipmentPopUp, site, position: baseXY } = this.state;

    const equipmentPopUpEquipment =
      equipmentPopUp && site.items[equipmentPopUp.index]
        ? site.items[equipmentPopUp.index]
        : null;

    if (!equipmentPopUpEquipment) {
      return {};
    }

    const popUpPosition = equipmentPopUpEquipment.position;

    let posTop = 0,
      posLeft = 0;

    if (popUpPosition) {
      //позиция попапа равна позиции активного изделия.
      const selectedEquipment = site.items.find((i) => {
        return i.limitColor !== "transparent";
      });

      if (this.state.siteCustom.viewTop) {
        //1. Рабочий вариант (но косяк в уползании вбок и вниз из-за того, что popUpPosition уже приходит увеличенным)
        let izoPos = HelperCanvas.calculateBackTransform(
          (popUpPosition.x - baseXY.x) / scale,
          (popUpPosition.y - baseXY.y) / scale,
          IZO_TRANSFORM_A,
          IZO_TRANSFORM_B,
          IZO_TRANSFORM_C,
          IZO_TRANSFORM_D,
          scale
        );

        posTop = (baseXY.y + izoPos.x) * scale - 180;
        posLeft = (baseXY.x + izoPos.y) * scale + 150;

        if (selectedEquipment) {
          posLeft = selectedEquipment.position.x * scale;
          posTop = selectedEquipment.position.y * scale;
        }
      } else {
        if (selectedEquipment) {
          posLeft = selectedEquipment.position.x * scale - 170;
          posTop = selectedEquipment.position.y * scale;
        }
      }
    }

    return {
      top: posTop,
      left: posLeft,
    };
  };

  getCurrentCategoryItems = () => {
    if (this.props.categories.searchResult.searchText) {
      return this.props.categories.searchResult.items;
    } else if (
      this.state.sidebar &&
      this.state.sidebar.currentCategory &&
      this.state.sidebar.currentCategory.pid
    ) {
      const pid = this.state.sidebar.currentCategory.pid;
      return this.props.categories.products[pid]
        ? this.props.categories.products[pid]
        : [];
    }
    return [];
  };

  saveAs = (type) => {
    //todo:: показать прелоудер показать модалку с результатом
    const {
      square: base,
      field,
      coordinates,
      position,
      scale,
      squareSize,
      grassMod,
    } = this.state;

    let borders = coordinates
      .map((c) => {
        return [c.x, c.y];
      })
      .reduce(function (curr, next) {
        return curr.concat(next);
      })
      .reverse();

    const fieldHeight = squareSize * field.height + squareSize * grassMod * 2;

    let imgs = [];
    let items = this.state.site.items.map((item) => {
      const activeIzoImgIndex = item.activeImgIndex || 0;

      //imgs.push(document.getElementById(`equipment_${item.id}`).toDataURL());

      //var canvas = document.getElementById(`equipment_${item.id}`);
      if (this.state.siteCustom.viewTop) {
        return {
          id: item.id,
          index: item.activeImgIndex,
          url: item.images[TOP_VIEW_IMAGE_INDEX],
          urlIzo: item.images[activeIzoImgIndex], //дополнительно передадим путь к izo картинке, для коррекции на середину ее размеров
          origin: item.origins[activeIzoImgIndex],
          x: item.position.x - position.x / scale,
          y: item.position.y - position.y / scale,
        };
      } else {
        return {
          id: item.id,
          index: item.activeImgIndex,
          url: item.images[activeIzoImgIndex],
          origin: item.origins[activeIzoImgIndex],
          x: item.position.x - position.x / scale + squareSize - 6,
          y: item.position.y - (position.y / scale - fieldHeight * 0.35),
        };
      }
    });
    //console.log(imgs)

    constructSaveAs(type, {
      id: this.state.playgroundId,
      viewTop: this.state.siteCustom.viewTop,
      base,
      field: {
        width: field.height,
        height: field.width,
      },
      imgs,
      items,
      borders,
      playground: {
        id: this.state.playgroundId,
        name: this.state.name,
        field,
        coordinates,
        square: base,
        position,
        scale,
        items: this.state.site.items,
      },
    }).then((r) => {
      if (r.url) {
        if (type === "pdf") {
          // Обновляем состояние и localStorage
          if (r.id) {
            // предполагаем, что сервер возвращает id в поле 'id'
            this.setState(
              {
                playgroundId: r.id,
              },
              () => {
                // Вызываем setToLocalStore после обновления состояния
                this.setToLocalStore();
              }
            );
          }
          this.toggleOrderModal(r);
        } else {
          this.toggleSaveImageModal(r.url);
        }
      }
    });
  };

  search = (q) => {
    this.setState({
      sidebar: { ...this.state.sidebar, collapse: false, isSearch: true },
    });
    this.props.search(q);
  };

  render() {
    const {
      width,
      height,
      scale,
      square: squareBg,
      sidebar,
      coordinates,
      paths,
      grounds,
      field,
      siteCustom,
      position,
      offset,
      equipmentPopUp,
      site,
    } = this.state;

    const items = { ...site.items };
    const { app, categories } = this.props;

    const equipmentPopUpEquipment =
      equipmentPopUp && site.items[equipmentPopUp.index]
        ? site.items[equipmentPopUp.index]
        : null;
    const cells = this.getCells();

    const isLoading = app.loader.visible || this.state.preLoader;

    const ENV_DEV = window.localStorage.getItem("env") === "dev";

    return (
      <div
        className={`Constructor Constructor-Sidebar_sidebar${
          sidebar.collapse ? "_collapsed" : ""
        } `}
      >
        {/*sidebar*/}
        <MenuLeft
          ref="ConstructorMenuLeft"
          {...{ ...sidebar, categories: categories.tree }}
          items={this.getCurrentCategoryItems()}
          toggle={this.toggleSidebarLeft}
          setCategory={this.setCategory}
          addItem={this.addEquipment}
          search={this.search}
          className={"Constructor-Sidebar"}
        />
        {/*sidebar*/}

        <Header
          ref="ConstructorHeader"
          newPlayground={this.newPlayground}
          toggle={this.toggleSiteCustom}
          toggleView={this.toggleView}
          updateFieldSize={this.updateFieldSize}
          updateGround={this.setGround}
          grounds={grounds}
          field={field}
          siteCustom={siteCustom}
          saveAs={this.saveAs}
          name={this.state.name}
          onNameChange={(name) => this.setState({ name })}
        />

        <section
          className="Constructor-Playground"
          ref={this.setPlaygroundRef}
          id="Constructor-Playground"
        >
          {!isLoading && (
            <main
              id="playground"
              ref="playground"
              onMouseUp={this.handlerOnMouseUp}
            >
              {this.state.siteCustom.active && (
                <button
                  className="btn btn-purple Constructor-SiteCustom-Toggle"
                  onClick={this.toggleSiteCustom}
                >
                  Закончить редактирование <br />
                  произвольной формы
                </button>
              )}
              <div
                onMouseDown={this.handlerOnMouseDown}
                onWheel={this.updateScale}
                onMouseMove={this.onMove}
              >
                <Site
                  ref="Site"
                  moveTo={this.updatePosition}
                  setCtx={this.setSiteCtx}
                  sizes={{ width, height, scale }}
                  coordinates={coordinates}
                  base={paths}
                  cells={cells}
                  field={field}
                  siteSelected={this.state.siteSelected}
                  dirt={this.state.dirt}
                  grass={this.state.grass}
                  square={this.state[squareBg]}
                  position={position}
                  offset={offset}
                  viewTop={this.state.siteCustom.viewTop}
                />

                {this.state.siteCustom.active && (
                  <SiteCustom
                    ref="SiteCustom"
                    setCtx={this.setSiteCtx}
                    toggleSiteSelected={this.toggleSiteSelected}
                    updateCoordinates={this.updateCoordinates}
                    moveTo={this.updatePosition}
                    sizes={{ width, height, scale }}
                    coordinates={coordinates}
                    field={this.state.field}
                    oldPosition={this.state.oldPosition}
                    position={position}
                    offset={offset}
                    viewTop={this.state.siteCustom.viewTop}
                  />
                )}

                {drawMode && (
                  <SiteDraw
                    ref="SiteDraw"
                    setCtx={this.setSiteCtx}
                    toggleSiteSelected={this.toggleSiteSelected}
                    updateBases={this.updateBases}
                    moveTo={this.updatePosition}
                    sizes={{ width, height, scale }}
                    coordinates={coordinates}
                    field={this.state.field}
                    base={paths}
                    cells={cells}
                    oldPosition={this.state.oldPosition}
                    position={position}
                    offset={offset}
                    viewTop={this.state.siteCustom.viewTop}
                  />
                )}

                {!drawMode &&
                  !this.state.siteCustom.active &&
                  site.items &&
                  site.items.map((item, i) => {
                    //группируенм логические группы
                    return (
                      <Equipment
                        ref={`Equipment_${item.id}`}
                        className="Constructor-Playground-Equipment"
                        key={`equipment-${item.id}-${i}`}
                        setCtx={this.setEquipmentCtx}
                        sizes={{
                          width,
                          height,
                          scale,
                          square: squareSize,
                          position,
                        }}
                        position={position}
                        data={item}
                        webp={this.state.webp}
                        zIndex={i}
                        viewTop={this.state.siteCustom.viewTop}
                        showContour={ENV_DEV}
                      />
                    );
                  })}
              </div>

              {equipmentPopUpEquipment && (
                <PopupEquipment
                  position={this.getEquipmentPopUpCoordinates()}
                  equipment={equipmentPopUp.equipment}
                  onClose={() => {
                    this.setState({ equipmentPopUp: null });
                  }}
                  cloneEquipment={this.cloneEquipment}
                  deleteEquipment={this.deleteEquipment}
                  moveEquipmentByDir={this.moveEquipmentByDir}
                  changeLayer={this.changeLayer}
                  turnEquipment={this.turnEquipment}
                />
              )}
            </main>
          )}

          {<PreLoader message={app.loader.message} isVisible={isLoading} />}

          <Modal
            size={"lg"}
            isOpen={this.state.modal.saveImage}
            toggle={this.toggleSaveImageModal}
            className="Constructor-Modal Constructor-Modal_save_img"
          >
            <ModalBody>
              {this.state.saveAsFile && (
                <img
                  className="Constructor-Modal-Image img-fluid"
                  src={this.state.saveAsFile}
                  alt="Площадка"
                />
              )}
              <br />

              <div className="Constructor-Modal-btns">
                <a
                  className="btn btn-purple"
                  href={this.state.saveAsFile}
                  download="Площадка.jpg"
                >
                  Сохранить
                </a>
                <a
                  className="btn btn-yellow"
                  onClick={this.toggleSaveImageModal}
                >
                  Отмена
                </a>
              </div>
            </ModalBody>
          </Modal>

          <Modal
            size={"lg"}
            isOpen={this.state.modal.orderModal}
            toggle={this.toggleOrderModal}
            className="Constructor-Modal Constructor-Modal_save_pdf"
          >
            {this.state.saveAsFile && (
              <ModalBody>
                {this.state.saveAsFile && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.saveAsFile.content,
                    }}
                  />
                )}
                <br />
                <div className="Constructor-Modal-btns">
                  <a
                    className="btn btn-purple"
                    href={this.state.saveAsFile.url}
                    download="Площадка.pdf"
                  >
                    Сохранить в pdf
                  </a>
                  {/*     <button className="btn btn-purple">Отправить</button>*/}
                  <a className="btn btn-yellow" onClick={this.toggleOrderModal}>
                    Отмена
                  </a>
                </div>
              </ModalBody>
            )}
          </Modal>
        </section>
        <Cart
          addItem={this.addEquipment}
          items={items}
          removeItem={this.removeItem}
        />
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      app: state.app,
      page: state.page,
      categories: state.categories,
    };
  },
  (dispatch) =>
    bindActionCreators(
      {
        catalogFindAll: Actions.catalog.findAll,
        search: Actions.catalog.search,
        findAllItemByCategoryId: Actions.catalog.findAllItemByCategoryId,
        hideAlert: Actions.app.hideAlert,
        init: Actions.app.init,
        setCity: Actions.app.setCity,
        loadCartFromLocalStore: Actions.cart.loadCartFromLocalStore,
      },
      dispatch
    )
)(Constructor);
